import apiSlice from 'renderer/shared/state/apiSlice';
import {
  GetTransactionDetailRequest,
  GetTransactionDetailResponse,
  ListTransactionsRequest,
  ListTransactionsResponse,
  ListTransactionsResponseSchema,
  TransactionDetailsSchema,
  UpdateTransactionNoteRequest,
  UpdateTransactionNoteResponse,
  UpdateTransactionNoteResponseSchema,
} from '../schemas/transaction.schemas';
import {
  RefundRequest,
  RefundResponse,
  RefundResponseSchema,
} from '../schemas/refund.schemas';

const extendedApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listTransactions: builder.query<
      ListTransactionsResponse,
      ListTransactionsRequest
    >({
      query: ({
        page,
        limit,
        search,
        sortBy,
        sortOrder,
        startDate,
        endDate,
      }) => {
        let queryParams = `page=${page}&limit=${limit}`;
        if (search) queryParams += `&search=${encodeURIComponent(search)}`;
        if (sortBy) queryParams += `&sortBy=${encodeURIComponent(sortBy)}`;
        if (sortOrder)
          queryParams += `&sortOrder=${encodeURIComponent(sortOrder)}`;
        if (startDate)
          queryParams += `&startDate=${encodeURIComponent(startDate)}`;
        if (endDate) queryParams += `&endDate=${encodeURIComponent(endDate)}`;
        return { url: `/transaction?${queryParams}`, method: 'GET' };
      },
      providesTags: ['Transaction'],
      extraOptions: {
        responseSchema: ListTransactionsResponseSchema,
      },
    }),
    getTransactionDetails: builder.query<
      GetTransactionDetailResponse,
      GetTransactionDetailRequest
    >({
      query: (transactionId) => ({
        url: `/transaction/${transactionId}`,
        method: 'GET',
      }),
      providesTags: ['Transaction'],
      extraOptions: {
        responseSchema: TransactionDetailsSchema,
      },
    }),
    refundTransaction: builder.mutation<RefundResponse, RefundRequest>({
      query: ({ transactionId, amount, note }) => ({
        url: `/transaction/refund/${transactionId}`,
        method: 'POST',
        body: { amount, note },
      }),
      invalidatesTags: ['Transaction'],
      extraOptions: {
        responseSchema: RefundResponseSchema,
      },
    }),
    updateTransactionNote: builder.mutation<
      UpdateTransactionNoteResponse,
      UpdateTransactionNoteRequest
    >({
      query: ({ transactionId, note }) => ({
        url: `/transaction/note/${transactionId}`,
        method: 'PATCH',
        body: { note },
      }),
      invalidatesTags: ['Transaction'],
      extraOptions: {
        responseSchema: UpdateTransactionNoteResponseSchema,
      },
    }),
  }),
});

export const {
  useListTransactionsQuery,
  useGetTransactionDetailsQuery,
  useRefundTransactionMutation,
  useUpdateTransactionNoteMutation,
} = extendedApi;
